import React from 'react'
import Experty from '../Components/Expert/Experty'
import { useTranslation } from 'react-i18next';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react'
import gsap from 'gsap';

gsap.registerPlugin(ScrollTrigger);

const Experties = () => {
  const { t } = useTranslation();

  const { contextSafe } = useGSAP(() => {
    const safeTween = contextSafe(() => {
      gsap.utils.toArray(".experties-group").forEach((group) => {
        gsap.from(group.children, {
          y: 50,
          opacity: 0,
          scale: 0,
          duration: 1.5,
          stagger: 0.8,
          filter: "blur(10px)",
          ease: "power3.out",
          scrollTrigger: {
            trigger: group,
            start: "top center",
            toggleActions: "play none none none",
            // markers: true,
          },
        });
      });
    });
    safeTween();
  }, []);

  return (
    <div className='bg-[#091c30] dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700'>
      <div className="sm:container mx-auto">
        <h1 className='text-center expert xs:text-5xl xxs:text-4xl sm:text-6xl font-bold font-serif text-white mb-8 pt-5'>
          {t("AllExperties")}
        </h1>

        <div className="flex flex-wrap items-center justify-center w-full text-center">
          {/* GROUP 1 */}
          <div className="experties-group flex flex-wrap justify-center w-full">
            <Experty image={"./images/htmlLogo.png"} BarValue={"100%..."} text={t("Html")} name={t("SeeMoreE")} />
            <Experty image={"./images/cssLogo2.png"} BarValue={"70%..."} text={t("CSS")} name={t("SeeMoreE")} />
            <Experty image={"./images/jsLogo.png"} BarValue={"70%..."} text={t("JavaScript")} name={t("SeeMoreE")} />
          </div>

          {/* GROUP 2 */}
          <div className="experties-group flex flex-wrap justify-center w-full">
            <Experty
              image={""}
              BarValue={"100%..."}
              svg=      {    <svg class="App-logo h-40 w-60" fill='blue' viewBox="0 0 841.9 595.3" xmlns="http://www.w3.org/2000/svg"><g fill="blue"><path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z"></path><circle r="45.7" cy="296.5" cx="420.9"></circle><path d="M520.5 78.1z"></path></g></svg>}

              text={t("React")}
              name={t("SeeMoreE")}
            />
            <Experty image={"./images/nlogo.png"} BarValue={"100%..."} text={t("Node")} name={t("SeeMoreE")} />
            <Experty image={"./images/tLogo.Default"} BarValue={"80%..."} text={t("Tailwind")} name={t("SeeMoreE")} />
          </div>

          {/* GROUP 3 */}
          <div className="experties-group flex flex-wrap justify-center w-full">
            <Experty image={"./images/tLogo.Default"} BarValue={"80%..."} text={t("Bootstrap")} name={t("SeeMoreE")} />
            <Experty image={"https://avatars.githubusercontent.com/u/54212428?v=4&s=400"} BarValue={"80%..."} text={t("Chakra")} name={t("SeeMoreE")} />
            <Experty image={"./images/GLogo.webp"} BarValue={"80%..."} text={t("Gsap")} name={t("SeeMoreE")} />
          </div>

          {/* GROUP 4 */}
          <div className="experties-group flex flex-wrap justify-center w-full">
            <Experty image={"./images/mongo.png"} BarValue={"80%..."} text={t("Mongo")} name={t("SeeMoreE")} />
            <Experty image={"./images/Jlogo.png"} BarValue={"50%..."} text={t("JQuery")} name={t("SeeMoreE")} />
            <Experty image={"https://www.rlogical.com/wp-content/uploads/2023/03/Rlogical-Blog-Images-thumbnail.webp"} BarValue={"50%..."} text={t("Next")} name={t("SeeMoreE")} />
          </div>

          {/* GROUP 5 */}
          <div className="experties-group flex flex-wrap justify-center w-full">
            <Experty image={"https://upload.wikimedia.org/wikipedia/commons/3/31/Python-logo.png"} BarValue={"80%..."} text={t("Python")} name={t("SeeMoreE")} />
            <Experty image={"./images/DJ.png"} BarValue={"80%..."} text={t("Django")} name={t("SeeMoreE")} />
            <Experty image={"https://cdn.icon-icons.com/icons2/2415/PNG/512/ruby_plain_wordmark_logo_icon_146362.png"} BarValue={"80%..."} text={t("Ruby")} name={t("SeeMoreE")} />
          </div>

        </div>
      </div>
    </div>
  )
}

export default Experties
